<template>
    <div
        v-if="!showText"
        class="sug-wrapper"
        :class="{'error': errorMsg}"
    >
        <el-select
            :value="+value===-1?'':value"
            clearable
            remote
            filterable
            v-bind="$attrs"
            :remote-method="remoteMethod"
            :disabled="disabled || judgeAttrUnderReview(modifiyAttrs, 'skuBaseCodeList')"
            style="width:100%"
            placeholder="请选择或输入搜索"
            @change="handleSelect"
            @focus="focusHandler"
        >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
        </el-select>
    </div>
    <span v-else>{{ listText }}</span>
</template>

<script>
/**
 * 生产者名称
 */
import { debounce } from '@lsfe/tools';
import Rules from '@lsfe/rules';
import emitter from 'utils/emitter';
import judgeAttrUnderReview from 'utils/spAttrsApprove';

export default {
    componentName: 'validate-input',
    mixins: [emitter],
    props: {
        value: {
            type: [String, Number],
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '请选择',
        },
        procWithoutQlf: {
            type: Boolean,
            default: true,
        },
        manufactureName: {
            type: String,
            default: '',
        },
        modifiyAttrs: {
            type: Array,
            default: () => [],
        },
        // 状态：1审核中 2正常 3审核驳回 4终止
        status: {
            type: Number,
            default: 2,
        },
        showText: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [],
            errorMsg: '',
            form: {
                producerName: '',
            },
            rules: {
                producerName: [
                    Rules.isRequired('生产者名称必填'),
                    Rules.lenRange({ max: 30 }, '生产者名称不能超过300个字'),
                ],
            },
            loading: false,
            judgeAttrUnderReview,
            innerManufactureName: this.manufactureName,
        };
    },
    computed: {
        listText() {
            const listMap = this.options.reduce((result, item) => {
                result[item.value] = item.label;
                return result;
            }, {});
            return listMap[this.value];
        },
    },
    watch: {
        errorMsg(newVal) {
            // eslint-disable-next-line no-unused-expressions
            this.showToast
                && newVal
                && this.$message.error(`以下信息有误: 1 ) ${newVal}`);
        },
    },

    mounted() {
        this.getAllManuInfo(this.innerManufactureName);
        this.showToast = false;
        this.$on('validate', this.broadcastValidate);
        this.$on('reset', this.reset);
    },
    methods: {
        // 因为在本页面，需要新建生产商并马上可供用户选择，因此在用户focus时，需要拉取生产商接口
        focusHandler() {
            this.getAllManuInfo();
        },
        broadcastValidate() {
            const errMsg = this.valid2(this.value, false);
            this.dispatch('validate-form', 'validate-message', errMsg);
        },
        reset() { },
        valid2(val, showToast = true) {
            this.showToast = showToast;

            this.errorMsg = '';
            if (this.required) {
                if (!val || val === '-1') {
                    this.errorMsg = '生产者名称不能为空';
                }
            }

            return this.errorMsg;
        },
        handleSelect(id) {
            let item = null;
            if (id) {
                item = this.options.find((i) => id === i.value);
            }
            if (item) {
                this.$emit('manufactureIdChanged', item.value);
                this.$emit('manufactureNameChanged', item.label);
                this.$emit('input', item.value);
            } else {
                this.$emit('manufactureIdChanged', '-1');
                this.$emit('manufactureNameChanged', '');
                this.$emit('input', '-1');
            }
        },
        getAllManuInfo(query) {
            return this.$hPost('/api/vss/shepherd/sqm/producer/getProducerGPage', {
                page: { offset: 0, limit: 100 },
                producerName: typeof query === 'string' ? query : '',
                producerId: null,
            })
                .then((data) => {
                    let result = [];
                    if (data && Array.isArray(data.infoList)) {
                        result = data.infoList.map((i) => ({
                            value: `${i.id}`,
                            label: i.name,
                        }));
                    }
                    this.loading = false;
                    this.options = result;
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error(err.message || '获取生产商列表失败');
                });
        },
        debounceQueryData: debounce(function (query) {
            this.getAllManuInfo(query);
        }, 1500),
        remoteMethod(query) {
            this.loading = true;
            this.debounceQueryData(query);
        },
    },
};
</script>
